import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, Select, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Rating, TextField, TextareaAutosize, Typography } from '@mui/material';
import qs from 'qs';
import oikosApi from '../../../services/oikos';
import { getRegs } from '../../../utils/fc';
import SearchableSelect from 'react-select';
import ModalFormAddFavBordero from '../../../components/Modals/ModalFormAddFavBordero/ModalFormAddFavBordero';

const DadosFavorecidoPf = ( props ) => {

  const [pf, setPf] = useState({});

  async function preloading() {

    if (Object.keys(props.selectedFav).length != 0) {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        fields: {},
        data: { pf_id: props.selectedFav.value }
      })}`);

      setPf(res.data[0])
    }
    else {
      setPf({})
    }
  }

  useEffect(() => {
    preloading()
  }, [props.selectedFav, props.refreshKey])

  const handleSelectChange = async (e) => {
    const selected = props.favs.find((pf) => {if(e) return pf.value === e.value});
    if (selected) {
      props.setSelectedFav(selected); // Update with the full pj object
      props.setFavChanged(true);
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        fields: {},
        data: { pf_id: selected.value }
      })}`);

      setPf(res.data[0])
    }
  };

    return (
        <DialogContent style={{overflow: 'visible'}}>
          <div className="d-flex">
            <div className='d-flex flex-column flex-fill'>
              <div>
                <span>Nome:</span><br/>
                <FormControl fullWidth>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar..."
                    defaultValue={props.favs.filter(x => x.value === props.data.bdro_favId)}
                    isDisabled={false}
                    isLoading={false}
                    isClearable={true}
                    isSearchable={true}
                    options={props.favs}
                    onChange={handleSelectChange}
                    value={props.selectedFav}
                  />
                </FormControl>
              </div>
              {
                (Object.keys(pf).length === 0)
                ?
                  <p>
                    Sem informações sobre o favorecido.
                  </p>
                :
                  <>
                    <div className='mt-3'>
                      <span>CPF: </span><strong>{pf?.pf_cpf}</strong>
                    </div>
                    <div className='mt-3'>
                      <span>Dados Bancários:</span><br/>
                      <div className='d-flex flex-column mt-3'>
                        <div className='d-flex flex-column justify-content-between'>
                        <span style={{marginBottom: '3px'}}>Titular: <strong>{Object.keys(pf).length != 0 ? pf.pf_contaTitNome || pf.pf_nomeExibicao : ''}</strong></span>
                        <span style={{marginBottom: '3px'}}>Doc Titular: <strong>{Object.keys(pf).length != 0 ? pf.pf_contaTitDoc : ''}</strong></span>
                        <span style={{marginBottom: '3px'}}>Banco: <strong>{Object.keys(pf).length != 0 ? pf.pf_contaBanco : ''}</strong></span>
                        <span style={{marginBottom: '3px'}}>Agência: <strong>{Object.keys(pf).length != 0 ? pf.pf_contaAgencia : ''}</strong></span>
                        <span style={{marginBottom: '3px'}}>Número: <strong>{Object.keys(pf).length != 0 ? pf.pf_contaNum : ''}</strong></span>
                        <span style={{marginBottom: '3px'}}>Pix: <strong>{Object.keys(pf).length != 0 ? pf.pf_chavePix : ''}</strong></span>
                        <span style={{marginBottom: '3px'}}>Tipo de conta: <strong>{Object.keys(pf).length != 0 ? pf.pf_contaTp : ''}</strong></span>
                        </div>
                      </div>
                    </div>
                  </>
              }
        </div>
      </div>
    </DialogContent>
  )
}

export default DadosFavorecidoPf;
